
import { ReactNode, memo } from "react";
import TopNavigation from "./TopNavigation";

interface MainContentProps {
  children: ReactNode;
  userRole: 'borrower' | 'lender' | 'admin' | 'vendor' | null;
  session: boolean;
  isMobile: boolean;
}

const MainContent = memo(({ children, userRole, session }: MainContentProps) => {
  const shouldShowNavigation = session && userRole && userRole !== 'borrower';

  return (
    <div className="min-h-screen w-full">
      {shouldShowNavigation && (
        <TopNavigation userRole={userRole} />
      )}
      <main className="container mx-auto px-4 py-8 pt-20">
        {children}
      </main>
    </div>
  );
});

MainContent.displayName = 'MainContent';

export default MainContent;
